export default function FollowBand() {
  return (
    <section id="follow" className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-accent-500 via-accent-500 to-primary-500 px-6 py-10 md:px-12 md:py-14">
        <div
          className="pointer-events-none absolute inset-0 opacity-20 [background-image:radial-gradient(circle_at_20%_30%,#fff,transparent_38%),radial-gradient(circle_at_85%_70%,#fff,transparent_35%)]"
          aria-hidden="true"
        ></div>

        <div className="relative grid grid-cols-1 items-center gap-8 lg:grid-cols-[1.2fr_0.8fr]">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-background-50/25 px-3 py-1 text-xs font-bold text-foreground-950">
              <i className="ri-user-follow-fill"></i> 关注即对接
            </span>
            <h2 className="mt-4 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-4xl">
              别让线索过期，
              <br />
              先关注再把料摆上桌。
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-800 md:text-base">
              关注 92爆料 频道后，一手线索、更新条与投稿入口会常驻你的首页。有料可报、有瓜可发，对接渠道始终明确。
            </p>
          </div>

          <div className="flex flex-col gap-3 lg:items-end">
            <a
              href="#top"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-6 py-3 text-base font-bold text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
            >
              <i className="ri-add-circle-fill text-accent-400"></i>
              一键关注频道
            </a>
            <div className="flex flex-col gap-3 sm:flex-row lg:flex-col">
              <a
                href="#top"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-foreground-950/25 bg-background-50/20 px-6 py-3 text-base font-semibold text-foreground-950 hover:bg-background-50/40 transition-colors cursor-pointer"
              >
                <i className="ri-download-2-line"></i>
                下载桌面版
                <span className="text-xs font-normal opacity-70">(演示)</span>
              </a>
              <a
                href="#talk"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-foreground-950/25 bg-background-50/20 px-6 py-3 text-base font-semibold text-foreground-950 hover:bg-background-50/40 transition-colors cursor-pointer"
              >
                <i className="ri-chat-voice-line"></i>
                加入讨论频道
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}